export default class DiscountUtil {
  /** @type {Discount|null} */
  __promo
  /** @type {Discount|null} */
  __wholeSale
  /** @type {number} */
  __seniorDiscountRate = null
  /** @type {number|null} */
  __retail = null
  /** @type {number|null} */
  __quantity = null
  /**
   * Description
   * @param {Discount} promo
   * @param {Discount} wholeSalem
   * @param {number} seniorDiscountRate
   */
  constructor(promo, wholeSale, seniorDiscountRate) {
    this.__promo = promo
    this.__wholeSale = wholeSale
    this.__seniorDiscountRate = seniorDiscountRate
  }

  get amount() {
    return this.__retail * (this.__quantity || 0)
  }

  get promoFixedDiscount() {
    if (this.__promo?.type === 'rate') return 0
    return ((this.__quantity || 0) * this.__promo?.value) || 0
  }

  get wholeSaleFixedDiscount() {
    if (this.__wholeSale?.type === 'rate') return 0
    return ((this.__quantity || 0) * this.__wholeSale?.value) || 0
  }

  /**
   * Description
   * @param {number} retail
   */
  setRetail(retail) {
    this.__retail = retail
  }

  /**
   * Description
   * @param {number} quantity
   */
  setQuantity(quantity) {
    this.__quantity = quantity
  }

  getDiscountRate() {
    return this.getDiscount() / this.amount
  }

  getDiscount() {
    if (!this.__promo && !this.__wholeSale) return this.amount * this.__seniorDiscountRate

    let action = 0
    action |= (this.__wholeSale?.type === 'rate') << 0
    action |= (this.__promo?.type === 'rate') << 1
    /**
     * actions
     * 0 - p (fixed) | w (fixed)
     * 1 - p (fixed) | w (rate)
     * 2 - p (rate)  | w (fixed)
     * 3 - p (rate)  | w (rate)
     */
    if (action === 0) {
      const partialDiscount = this.promoFixedDiscount + this.wholeSaleFixedDiscount
      const amountLessDiscount = this.amount - partialDiscount
      const seniorDiscount = amountLessDiscount * this.__seniorDiscountRate
      console.log({ amountLessDiscount, seniorDiscount, partialDiscount, pfd: this.promoFixedDiscount, wsfd: this.wholeSaleFixedDiscount })
      return partialDiscount + seniorDiscount
    }
    if (action === 1) {
      const discountedAmount = this.amount - this.promoFixedDiscount
      const wholeSaleDiscount = discountedAmount * this.__wholeSale.value
      const seniorDiscount = (discountedAmount - wholeSaleDiscount) * this.__seniorDiscountRate
      return this.promoFixedDiscount + wholeSaleDiscount + seniorDiscount
    }
    if (action === 2) {
      const promoDiscount = this.amount * this.__promo.value
      const discountedAmount = this.amount - promoDiscount
      const seniorDiscount = (discountedAmount - this.wholeSaleFixedDiscount) * this.__seniorDiscountRate
      return promoDiscount + this.wholeSaleFixedDiscount + seniorDiscount
    }
    if (action === 3) {
      const discountedAmount = this.amount * (1 - this.promo.value) * (1 - this.__wholeSale.value)
      const seniorDiscount = discountedAmount * this.__seniorDiscountRate
      return this.amount - discountedAmount + seniorDiscount
    }
    return 0
  }
}

/**
 * @typedef {'rate'|'fixed'} DiscountType
 * 
 * @typedef {Object} Discount
 * @property {DiscountType} type 
 * @property {number} value
 * 
 */